<template>
  <div>
    <div class="navbar">
      <div class="navbar-container">
        <router-link to="/">
          <img class="navbar-logo" src="@/assets/imgs/home/logo-head.png" />
        </router-link>

        <div class="navbar-options">
          <router-link
            to="/"
            :class="['options-item', { active: currentRoute === 'home' }]"
          >
            <div class="text">开放平台</div>
            <div class="line"></div>
          </router-link>
          <a :href="documentHref" class="options-item">
            <div class="text">开发者文档</div>
            <div class="line"></div>
          </a>
          <router-link
            to="/app-stores"
            :class="['options-item', { active: currentRoute.includes('app-') }]"
          >
            <div class="text">应用商店</div>
            <div class="line"></div>
          </router-link>
        </div>
      </div>
      <div v-if="init" class="nav-user-box">
        <div v-if="hasLogin" class="nav-user-inner">
          <img
            class="nav-user-avatar-img"
            src="../../../assets/imgs/avatar.png"
            width="100%"
            alt=""
          />
          <div class="nav-user-info nav-more">
            <span class="nav-user-name">{{ userName }}</span>
            <div class="nav-menu-sub-list">
              <div class="nav-menu-sub-box">
                <div class="nav-menu-sub-item" @click="navItemClick('/myapp')">
                  <span class="nav-name">我的应用</span>
                </div>
                <div
                  class="nav-menu-sub-item"
                  @click="navItemClick('/user/account-safety')"
                >
                  <span class="nav-name">个人中心</span>
                </div>
                <div class="nav-menu-sub-item" @click="logoutHandler">
                  <span class="nav-name">退出登录</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="nav-user-login" @click="loginHandler">登录</div>
      </div>
    </div>
    <div class="navbar-static"></div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  watch
} from '@vue/composition-api'
import $http from '@/api'
import { UserModule } from '@/store/modules/user'
import router from '@/router'

export default defineComponent({
  name: 'NavBar',
  setup(props, { root }) {
    const documentHref = ref(
      `${location.origin}/document/#/docs/1-开发必读/1-应用类型介绍`
    )
    const state = reactive({
      hasLogin: UserModule.hasLogin,
      init: UserModule.init,
      userName: UserModule.userInfo.phone
    })
    const loginHandler = () => {
      if (root.$route.path !== '/login') {
        root.$router.push({
          path: '/login'
        })
      }
    }
    const logoutHandler = async () => {
      const { errNo } = await $http.logout({ client: 5 }, { isForm: true })
      if (errNo === 0) {
        root.$router.push({
          path: '/login'
        })
      }
    }
    const navItemClick = (path) => {
      if (root.$route.path !== path) {
        root.$router.push({
          path
        })
      }
    }
    // 更新路由
    const currentRoute = ref('')
    // 更新路由 不要放太深逻辑，执行会叠加
    const getRoute = (val) => {
      const route = val.split('/')[1]
      currentRoute.value = route
    }
    getRoute(root.$route.path)
    // watch跳转时会报错监听路由变化，故而用beforeEach，内部代码执行会叠加，不要放太深逻辑
    router.beforeEach(function (to, from, next) {
      getRoute(to.path)
      next()
    })
    watch(
      () => UserModule.hasLogin,
      (val) => {
        state.hasLogin = val
        state.init = UserModule.init
        state.userName = UserModule.userInfo.phone
      },
      { immediate: true }
    )
    return {
      ...toRefs(state),
      loginHandler,
      logoutHandler,
      navItemClick,
      currentRoute,
      documentHref
    }
  }
})
</script>

<style scoped lang="scss">
.navbar {
  position: fixed;
  width: 100%;
  height: 60px;
  top: 0;
  z-index: 99;
  padding: 0 20px 0 32px;
  background: #fff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
}
.navbar-static {
  height: 60px;
}

.navbar .navbar-container {
  display: flex;
  height: 100%;
  align-items: center;
}

.navbar-logo {
  width: 188px;
  height: 22px;
}

.navbar-logo:hover {
  cursor: pointer;
}

.navbar-options {
  height: 100%;
  display: flex;
  justify-content: center;
  margin-left: 117px;
}
.options-item {
  height: 100%;
  position: relative;
  font-size: 16px;
  margin-right: 64px;
  .text {
    line-height: 60px;
    white-space: nowrap;
  }
}
.line {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 3px;
  background: #186fff;
  border-radius: 2px;
  display: none;
}

.options-item:hover {
  color: #186fff;
  cursor: pointer;
}
.active {
  color: #186fff;
  font-weight: 500;
  .line {
    display: block;
  }
}
.nav-user-login {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #2372f6;
  cursor: pointer;
  padding: 10px;
  white-space: nowrap;
}
.nav-user-inner {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 16px;
}
.nav-user-avatar-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.nav-user-info {
  display: flex;
  margin-left: 6px;
  cursor: pointer;
  padding: 5px 20px 5px 5px;
  line-height: normal;
}
.nav-user-name {
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-more {
  position: relative;
  padding-right: 20px;
}
.nav-more::after {
  position: absolute;
  top: 50%;
  right: 5px;
  content: '';
  width: 7.071px;
  height: 7.071px;
  border-right: 1px solid #979797;
  border-bottom: 1px solid #979797;
  transform: translateY(-50%) rotate(45deg);
  transition: transform 0.2s;
  transform-origin: 50% 70%;
}
.nav-more:hover::after {
  content: '';
  transform: translateY(-50%) rotate(225deg);
}
.nav-menu-sub-list {
  position: absolute;
  right: 0;
  top: 65%;
  padding: 8px 0;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgb(0 0 0 / 16%);
  border-radius: 4px;
  visibility: hidden;
  transition: top 0.2s;
}
.nav-menu-sub-box {
  width: 160px;
  height: 0;
  max-height: 240px;
  margin-right: 3px;
  overflow-y: auto;
  transition: height 0.2s;
}
.nav-user-info:hover .nav-menu-sub-list {
  visibility: visible;
  top: 100%;
}
.nav-user-info:hover .nav-menu-sub-box {
  height: auto;
}
.nav-menu-sub-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 16px;
  cursor: pointer;
  height: 48px;
}
.nav-menu-sub-item:hover {
  background-color: #f8f8f8;
}
.nav-menu-sub-item:hover .nav-name {
  color: #2372f6;
}
.nav-name {
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
